import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-49bce1dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Juanjo Ruiz", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "section" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Especialidades:"),
    /*#__PURE__*/_createElementVNode("label", null, "Vue / Laravel / Solid")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "separator" }),
  /*#__PURE__*/_createElementVNode("div", { class: "section" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "País:"),
    /*#__PURE__*/_createElementVNode("label", null, "España")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "separator" }),
  /*#__PURE__*/_createElementVNode("div", { class: "section" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Ciudad:"),
    /*#__PURE__*/_createElementVNode("label", null, "Málaga")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "separator" }),
  /*#__PURE__*/_createElementVNode("div", { class: "section" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Tarifa:"),
    /*#__PURE__*/_createElementVNode("label", null, "10€")
  ])
], -1))
const _hoisted_4 = { class: "container is-light-mode" }

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { Qalendar } from "qalendar";
import QEvent from '@/interfaces/QEvent'


export default /*#__PURE__*/_defineComponent({
  __name: 'TeachersDetailView',
  setup(__props) {

const events: QEvent[] = [
  {
    title: "BBDD",
    with: "Juanjo Ruiz",
    time: { start: "2024-02-16 12:05", end: "2024-02-16 13:35" },
    color: "blue",
    isEditable: true,
    id: "753944708f0f",
    description: "Clase de base de datos en DIGITECH"
  },
  {
    title: "JavaScript",
    with: "Alejandro",
    time: { start: "2024-01-10", end: "2024-01-11" },
    color: "green",
    isEditable: true,
    id: "5602b6f589fc"
  }
  // ... otros eventos
];

const config = {
  // configuración del calendario
  
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Qalendar), {
          events: events,
          config: config
        })
      ])
    ]),
    _: 1
  }))
}
}

})